import en from './en.json';
import ru from './ru.json';

const ruTyped = ru;
const enTyped = en;

export { ruTyped as ru, enTyped as en };
